module.exports = __webpack_public_path__ + "img/logo_small_white.33bb8bf7.png";